export default "__VITE_ASSET__4f4fe084__"